import type { AppIconProps } from "../IconTypes";

export const BackArrowIcon: React.FC<AppIconProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2513 0C20.4503 0 20.641 0.0790176 20.7817 0.21967C20.9223 0.360322 21.0013 0.551088 21.0013 0.75V7.95C21.0013 8.44246 20.9043 8.93009 20.7159 9.38506C20.5274 9.84003 20.2512 10.2534 19.903 10.6016C19.5548 10.9499 19.1414 11.2261 18.6864 11.4145C18.2314 11.603 17.7438 11.7 17.2513 11.7H2.56184L7.58234 16.719C7.72317 16.8598 7.80229 17.0508 7.80229 17.25C7.80229 17.4492 7.72317 17.6402 7.58234 17.781C7.44151 17.9218 7.2505 18.0009 7.05134 18.0009C6.85218 18.0009 6.66117 17.9218 6.52034 17.781L0.220341 11.481C0.150496 11.4113 0.0950815 11.3286 0.0572719 11.2374C0.0194622 11.1463 0 11.0487 0 10.95C0 10.8513 0.0194622 10.7537 0.0572719 10.6625C0.0950815 10.5714 0.150496 10.4887 0.220341 10.419L6.22034 4.419C6.36117 4.27817 6.55218 4.19905 6.75134 4.19905C6.9505 4.19905 7.14151 4.27817 7.28234 4.419C7.42317 4.55983 7.50229 4.75084 7.50229 4.95C7.50229 5.14916 7.42317 5.34017 7.28234 5.481L2.56184 10.2H17.2513C17.8481 10.2 18.4204 9.96295 18.8423 9.54099C19.2643 9.11903 19.5013 8.54674 19.5013 7.95V0.75C19.5013 0.551088 19.5804 0.360322 19.721 0.21967C19.8617 0.0790176 20.0524 0 20.2513 0Z"
        fill="#1D9F81"
      />
    </svg>
  );
};
